import moment from 'moment';
import { isFreeTx } from './Transaction';

const getSectionProgresses = (classModel) => {
  const sectionProgresses = {};
  let number = 1;
  switch (classModel.class_type) {
    case 'single':
      for (const chapter of classModel.ClassChapters) {
        for (const section of chapter.ClassSections) {
          sectionProgresses[number + '차시'] = section.section_completion_rate
            ? section.section_completion_rate + '%'
            : '-';
          number++;
        }
      }
      break;
    case 'package':
      for (const classSinglePackage of classModel.ClassSingle_ClassPackages) {
        for (const chapter of classSinglePackage.FK_class_single.ClassChapters) {
          for (const section of chapter.ClassSections) {
            sectionProgresses[`${number}차시`] = section.section_completion_rate
              ? section.section_completion_rate + '%'
              : '-';
            number++;
          }
        }
      }
      break;
    default:
      break;
  }
  return sectionProgresses;
};

const getBeforeSurveyStatus = (userClass) => {
  if (userClass.survey_pre_done !== 0) {
    if (userClass.survey_pre_done === -1) return '미완료';
    if (userClass.survey_pre_done === 1) return '완료';
  }
  const beforeSurvey = userClass.survey_chapters.find((chapter) => chapter.timing === 'before');
  if (!beforeSurvey) return '설문 없음';
  return beforeSurvey.isCompleted ? '완료' : '미완료';
};

const getAfterSurveyStatus = (userClass) => {
  if (userClass.survey_post_done !== 0) {
    if (userClass.survey_post_done === -1) return '미완료';
    if (userClass.survey_post_done === 1) return '완료';
  }
  const afterSurvey = userClass.survey_chapters.find((chapter) => chapter.timing === 'after');
  if (!afterSurvey) return '설문 없음';
  return afterSurvey.isCompleted ? '완료' : '미완료';
};

const getScheduleOption = (userClass, intl) => {
  if (userClass.FK_class_offline_schedule_id) {
    const s = userClass.FK_class_offline_schedule;
    const weekdays = s.class_dates
      .split('')
      .map((d, i) => (+d !== 0 ? intl.formatMessage({ id: 'ID_WEEKDAY_' + (i + 1) }) : ''))
      .join('');
    return `${s.class_round ? `${s.class_round}기` : ''} | ${
      s.title ? `${s.title} |` : '옵션명 없음 | '
    } ${weekdays} | ${s.class_start_time} | ${s.start_date}~${s.end_date}`;
  }
  if (userClass.FK_class_online_schedule_id) {
    const s = userClass.FK_class_online_schedule;
    return `${s.class_round}기 | ${s.title ? `${s.title} |` : '옵션명 없음 | '} ${s.start_date}~${s.end_date}${
      s.class_start_time ? ` | ${s.class_start_time}~${s.class_end_time}` : ' | 강의 시간 없음'
    }`;
  }
  return '';
};

export const buildThirdPartyExcelRow = (userClass, intl) => {
  const classModel = userClass.FK_class;
  const registerInfo = userClass.ThirdPartyClassRegistrations[0] ?? {};
  const isFree = isFreeTx(userClass.FK_tx);
  const txStatus = {
    ready: '결제대기',
    paid: '결제',
    partial_cancelled: '부분환불',
    cancelled: isFree ? '취소' : '환불',
  };

  return {
    회원ID: userClass.FK_user.id,
    닉네임: userClass.FK_user.nickname,
    이름: userClass.FK_user.name,
    국가정보: userClass.FK_user.FK_country?.name_kor || '-',
    이메일: userClass.FK_user.email,
    핸드폰번호: userClass.FK_user.phone ? userClass.FK_user.phone.toPhone() : '-',
    '혜택 수신 동의': userClass.FK_user.is_marketing_on ? '동의' : '비동의',
    '이름(신청서)': registerInfo.user_name ?? '-',
    '생년월일(신청서)': registerInfo.user_birth ? moment.utc(registerInfo.user_birth).format('YYYY-MM-DD') : '-',
    '핸드폰(신청서)': registerInfo.user_phone ? registerInfo.user_phone.toPhone() : '-',
    '이메일(신청서)': registerInfo.user_email ?? '-',
    '수강자 유형(신청서)': registerInfo.user_type
      ? registerInfo.user_type === '기타'
        ? `${registerInfo.user_type}(${registerInfo.user_type_name})`
        : registerInfo.user_type
      : '-',
    '성별(신청서)': registerInfo.user_gender ? (registerInfo.user_gender === 'M' ? '남자' : '여자') : '-',
    '최종 학력(신청서)': registerInfo.user_education ?? '-',
    '졸업 연도(신청서)': registerInfo.user_graduation_year ?? '-',
    '졸업 월(신청서)': registerInfo.user_graduation_month ? `${registerInfo.user_graduation_month}월` : '-',
    '졸업학교명(신청서)': registerInfo.user_school_name ?? '-',
    '졸업학과명(신청서)': registerInfo.user_school_department ?? '-',
    '신청동기(신청서)': registerInfo.user_apply_reason ?? '-',
    '사전 질문(신청서)': registerInfo.user_pre_question ?? '-',
    '추천인(신청서)': registerInfo.user_recommender ?? '-',
    제공사: classModel.host === 'ours' ? '자사' : classModel.host === 'gov' ? '정부' : '타사',
    강의ID: classModel.id,
    강의명: classModel.title,
    수강옵션: getScheduleOption(userClass, intl),
    '사전 설문조사 여부': getBeforeSurveyStatus(userClass),
    '사후 설문조사 여부': getAfterSurveyStatus(userClass),
    강사명: classModel.Class_Tutors.map((t) => t.FK_tutor.name).join(','),
    구분: intl.formatMessage({ id: 'ID_LISTEN_TYPE_' + classModel.listen_type.toUpperCase() }),
    결제상태: txStatus[userClass.FK_tx.status],
    결제일:
      userClass.FK_tx.deletedAt || !userClass.FK_tx.date_paid_at
        ? '-'
        : moment.utc(userClass.FK_tx.date_paid_at).format('YYYY-MM-DD'),
    콘텐츠지급일: userClass.FK_tx.deletedAt ? moment.utc(userClass.FK_tx.createdAt).format('YYYY-MM-DD') : '-',
    수강시작일: userClass.start_date ? moment.utc(userClass.start_date).format('YYYY-MM-DD') : '-',
    수강종료일: userClass.end_date ? moment.utc(userClass.end_date).format('YYYY-MM-DD') : '-',
    남은일수: userClass.count_left_day ? userClass.count_left_day + '일' : '-',
    정가: classModel.price_original,
    결제금액: userClass.FK_tx.paid_amount - userClass.FK_tx.canceled_amount,
    '강의자료 다운로드': userClass.is_download_attached_file ? '다운로드 후' : '다운로드 전',
    진도율: userClass.completion_rate ? userClass.completion_rate + '%' : '-',
    '수료증 발급': userClass?.User_Certificates[0]?.url_certificate_file ? '발급' : '미발급',
    ...getSectionProgresses(classModel),
  };
};
